import React, {
  FC,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import RowBetween from '../../../../../../../components/Layout/RowBetween';
import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import Button from '../../../../../../../components/Button';

const Title: FC<Props> = ({
  onClose,
}) => {
  return (
    <RowBetween style={{ marginTop: '20px', alignItems: 'center' }}>
      {/* 返回箭头 */}
      <Button
        style={{ marginLeft: '15px', marginTop: '-15px' }}
        onClick={() => {
          if (onClose) {
            onClose();
          }
        }}
      >
        <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
      </Button>
      <SquadSemiBoldText fontSize={26} lineHeight={30}>
        Search for recipient
      </SquadSemiBoldText>
      {/* 用于和左侧返回箭头配合布局 */}
      <div style={{ width: '20px', marginRight: '25px', paddingRight: '1em' }} />
    </RowBetween>
  );
};

export interface Props {
  onClose?: () => void;
}

export default Title;
